const plans = {
  trial: 'trial',
  free: 'free',
  premium: 'premium',
}
export type Plans = keyof typeof plans | null;

/**
 * トライアルかどうかを返す
 * @param serviceContractType 
 * @returns 
 */
 export const isTrial = (serviceContractType?: Plans) => {
  if(!serviceContractType || !plans[serviceContractType]) throw new Error('invalid service contract type');
  return "trial" === serviceContractType;
}

/**
 * フリープランかどうかを返す
 * @param serviceContractType 
 * @returns 
 */
export const isFree = (serviceContractType?: Plans) => {
  if(!serviceContractType || !plans[serviceContractType]) throw new Error('invalid service contract type');
  return "free" === serviceContractType;
}

/**
 * プレミアムプランかどうかを返す
 * @param serviceContractType 
 * @returns 
 */
export const isPremium  =(serviceContractType?: Plans) => {
  if(!serviceContractType || !plans[serviceContractType]) throw new Error('invalid service contract type');
  return "premium" === serviceContractType;
}
